import React from 'react';
import { Flex, Image, Text } from '@homeexchange/design';
import Utils from '../../../utils/utils';
import i18n from '../../../i18n';

const CollectionMemberBadge = () => {
    const base = `${Utils.getCloudfrontDomain()}/images/website/badge-v2/collection`;
    const faviconSrc = `${base}/collection-favicon.svg`;

    return (
        <Flex alignItems="center" direction="row" gap="4" flexWrap="nowrap">
            <Image src={faviconSrc} alt="Collection icon" />
            <Flex direction="column" gap="1">
                <Text isBold>{i18n.t('collection:page_collectionMember_title')}</Text>
                <Text isSmall>{i18n.t('collection:page_collectionMember_subtitle')}</Text>
            </Flex>
        </Flex>
    );
};

export default CollectionMemberBadge;
